import { OrderActivityLog, OrderActivityLogType } from '@/features/orders/types/app'
import { TFunction } from 'i18next'

interface ActivityPresentationPart {
    emphasis?: boolean
    text: string
}

interface ActivityPresentation {
    parts: ActivityPresentationPart[]
}

export const getActivityPresentation = (
    activityLog: OrderActivityLog,
    t: TFunction<'app'>
): ActivityPresentation => {
    switch (activityLog.type) {
        case OrderActivityLogType.Created:
            return { parts: [{ text: t('order.detail.history.activity.created') }] }
        case OrderActivityLogType.Paid:
            return { parts: [{ text: t('order.detail.history.activity.paid') }] }
        case OrderActivityLogType.Accepted: {
            const shift = activityLog.payload?.deliveryTimeShiftMinutes
            const deliveryTimeShift =
                typeof shift === 'number' && Number.isInteger(shift) && shift !== 0 ? shift : null

            return deliveryTimeShift === null
                ? { parts: [{ text: t('order.detail.history.activity.accepted') }] }
                : {
                      parts: [
                          { text: `${t('order.detail.history.activity.acceptedWithShift')} ` },
                          {
                              emphasis: true,
                              text: `${deliveryTimeShift > 0 ? '+' : ''}${deliveryTimeShift} ${t('timeUnit.min')}`,
                          },
                      ],
                  }
        }
        case OrderActivityLogType.Cancelled:
            return { parts: [{ text: t('order.detail.history.activity.cancelled') }] }
        case OrderActivityLogType.SentToProduction:
            return { parts: [{ text: t('order.detail.history.activity.sentToProduction') }] }
        case OrderActivityLogType.Ready:
            return { parts: [{ text: t('order.detail.history.activity.ready') }] }
        case OrderActivityLogType.Delivering:
            return { parts: [{ text: t('order.detail.history.activity.delivering') }] }
        case OrderActivityLogType.Delivered:
            return { parts: [{ text: t('order.detail.history.activity.delivered') }] }
        default:
            return { parts: [{ text: activityLog.type }] }
    }
}
